<template>
  <template v-if="results && task">
    <div
      v-for="result in resultsWithComments"
      :key="result.id"
      :class="{ 'task-comment': true, 'task-comment--with-attachments': hasAttachments(result) }"
    >
      <div class="task-comment__header typo-small">
        <div class="task-comment__capture-date">
          {{ formatDate(result.captured_at) }}
        </div>
        <div class="task-comment__name">
          {{ result.name }}
        </div>
        <div class="task-comment__value">
          {{ formatNumber(parseFloat(result.data.value)) }} {{ task.values.unit }}
        </div>
      </div>

      <div class="task-comment__text typo-small-title">
        {{ result.comments }}
      </div>

      <div
        v-if="hasAttachments(result)"
        class="task-comment__attachments"
      >
        <a
          v-for="doc in result.task_result_attachments"
          :key="doc.id"
          :href="doc.url"
          target="_blank"
        >
          <img
            class="task-comment__attachment"
            :src="doc.preview"
          >
        </a>
      </div>
    </div>
  </template>
  <Loader
    v-else
    class="task-details__loader"
  />
</template>

<script setup>
import { computed, inject } from 'vue';

import { formatDate } from '@/functions/date_format_helpers';

import Loader from '@/components/generic/loader.vue';

defineProps({
  organisationId: { type: String, required: true },
  operationId: { type: String, required: false, default: null },
  equipmentId: { type: String, required: false, default: null },
  planId: { type: String, required: true },
  pointId: { type: String, required: true },
  taskId: { type: String, required: true },
});

const task = inject('task');
const results = inject('results');

const resultsWithComments = computed(() => {
  return results.value?.filter(result => {
    return result.comments || hasAttachments(result);
  }) || [];
});

const numberFormat = new Intl.NumberFormat();
function formatNumber(value) {
  if (typeof value !== 'number') return '-';
  return numberFormat.format(value);
}

function hasAttachments(result) {
  return result.task_result_attachments && result.task_result_attachments.length > 0;
}
</script>
